<template>
  <div class="inner-box">
    <div class="content-name">
      <h2 class="dp-ib">방문 관리</h2>
      <div class="btn-wrap btn-type1 clearfix">
        <button class="btn-size btn-gray fl_left" @click="goBack()">
          <span class="btn-icon">
            <i class="fas fa-arrow-circle-left"></i>
          </span>
          뒤로가기
        </button>
      </div>
    </div>

    <visit-control-mg-base :visitNo="visitNo" v-model="data" :status="status" />
  </div>
</template>

<script>
import visit from '@/mixin/visit-basic'

export default {
  mixins: [visit],
  data() {
    return {
      name: 'VisitControlMgMng',
      data: {
        visitDetails: []
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>
